
import React, { createContext, useState } from 'react';

export const RefreshContext = createContext();

export const RefreshComp = ({ children }) => {
  const [refreshJobs, setRefreshJobs] = useState(false);

  return (
    <RefreshContext.Provider value={{ refreshJobs, setRefreshJobs }}>
      {children}
    </RefreshContext.Provider>
  );
};